import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Box, Skeleton } from '@ace-clublabs/shared-component-library';
import { IGetManifest } from '@ace-clublabs/payment-types';
import { IGetAdyenSession } from '../api/contracts';
import { sources } from '../api/sources';
import { postToParent } from '../components/EmbedAdyenPayment/embedPostMessage';
import LogCannon from '@ace-clublabs/log-cannon';
import EmbedAdyenPaymentRouter from './EmbedAdyenPaymentRouter';
import '../components/EmbedAdyenPayment/EmbedAdyenPayment.scss';

interface EmbedProps {
  manifestId: string;
  manifest: IGetManifest;
  adyenSession: IGetAdyenSession;
}

const EmbedPaymentLoader: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [embedProps, setEmbedProps] = useState<EmbedProps | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const manifest = await sources.getManifest(id ?? '');
        const adyenSession = await sources.getAdyenSession(id ?? '');
        setEmbedProps({ manifestId: id!, manifest, adyenSession });
      } catch (e: any) {
        LogCannon.blast('EmbedPaymentLoader: failed to load', { error: e, manifestId: id });
        setError('Failed to load payment form. Please refresh and try again.');
        postToParent('PAYMENT_ERROR', { errorCode: 'InitError', message: e?.message ?? 'Failed to load' });
      }
    })();
  }, [id]);

  if (embedProps) {
    return <EmbedAdyenPaymentRouter {...embedProps} />;
  }

  return (
    <div className="embed-adyen-payment">
      <Box
        className="embed-payment-info-box"
        sx={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '14px', padding: '24px', mb: '30px' }}
      >
        {error ? (
          <div role="alert">{error}</div>
        ) : (
          <div className="embed-adyen-payment-skeleton">
            <Skeleton className="embed-adyen-payment-skeleton__title" variant="rectangular" height={20} />
            <Skeleton className="embed-adyen-payment-skeleton__subtitle" variant="rectangular" height={20} />
          </div>
        )}
      </Box>
      <Skeleton className="embed-adyen-payment-skeleton__button" variant="rectangular" height={48} />
    </div>
  );
};

export default EmbedPaymentLoader;
